(() => {

  if (window.__iwProductHubLoaded) {
    return;
  }


  window.__iwProductHubLoaded = true;



  /* =========================================================
     INITIALIZE PRODUCT HUBS
     ========================================================= */

  const initializeHubs = () => {

    document
      .querySelectorAll(
        '[data-iw-product-hub]'
      )
      .forEach(root => {

        if (
          root.dataset.ready === '1'
        ) {
          return;
        }



        /* =====================================================
           FIND HUB ELEMENTS BEFORE PORTAL
           ===================================================== */

        const overlay =
          root.querySelector(
            '[data-iw-hub-overlay]'
          );


        const modal =
          root.querySelector(
            '[data-iw-hub-modal]'
          );


        const content =
          root.querySelector(
            '[data-iw-hub-content]'
          );


        const openButton =
          root.querySelector(
            '[data-iw-hub-open]'
          );


        const closeButtons =
          Array.from(
            root.querySelectorAll(
              '[data-iw-hub-close]'
            )
          );


        const viewButtons =
          Array.from(
            root.querySelectorAll(
              '[data-iw-hub-view]'
            )
          );


        const panels =
          Array.from(
            root.querySelectorAll(
              '[data-iw-hub-panel]'
            )
          );


        const topbarTitle =
          root.querySelector(
            '[data-iw-hub-topbar-title]'
          );


        const homeButton =
          root.querySelector(
            '[data-iw-hub-home-button]'
          );


        if (
          !overlay ||
          !modal ||
          !content ||
          !openButton ||
          !panels.length
        ) {
          return;
        }


        root.dataset.ready = '1';



        /* =====================================================
           PORTAL MODAL DIRECTLY TO BODY
           ===================================================== */

        /*
          The product details column can create its
          own positioning context.

          Keeping the overlay directly under BODY
          guarantees that the Hub occupies the real
          browser viewport rather than the product
          information column.
        */

        if (
          overlay.parentElement !==
          document.body
        ) {

          document.body.appendChild(
            overlay
          );

        }



        let lastFocusedElement =
          null;



        /* =====================================================
           VIEW TITLES
           ===================================================== */

        const viewTitles = {

          home:
            'Product Information Hub',

          product:
            'Product Information',

          description:
            'Product Description',

          'print-films':
            'Print Films',

          'print-film-1':
            '3M IJ180mC-10',

          'print-film-2':
            '3M IJ180mCv3-10',

          'print-film-3':
            'Avery Dennison MPI 1105',

          'print-film-4':
            '3M IJ180mC-120',

          application:
            'Application Guide',

          policies:
            'Our Policies',

          'policy-general':
            'General Policy',

          'policy-shipping':
            'Shipping Policy',

          'policy-returns':
            'Returns & Refunds Policy',

          'policy-privacy':
            'Privacy Policy'

        };



        /* =====================================================
           MAIN CATEGORY
           ===================================================== */

        const getMainCategory = view => {

          const productViews = [

            'product',
            'description',
            'print-films',

            'print-film-1',
            'print-film-2',
            'print-film-3',
            'print-film-4'

          ];


          const policyViews = [

            'policies',
            'policy-general',
            'policy-shipping',
            'policy-returns',
            'policy-privacy'

          ];


          if (
            productViews.includes(
              view
            )
          ) {
            return 'product';
          }


          if (
            policyViews.includes(
              view
            )
          ) {
            return 'policies';
          }


          if (
            view === 'application'
          ) {
            return 'application';
          }


          return 'home';

        };



        /* =====================================================
           CODED MODULE IFRAME ENGINE
           ===================================================== */

        const loadModule = panel => {

          if (!panel) {
            return;
          }


          /*
            If this module has already been
            converted into an iframe, leave
            it alone.
          */

          if (
            panel.querySelector(
              '.iw-hub__module-frame'
            )
          ) {
            return;
          }


          const template =
            panel.querySelector(
              'template[data-iw-hub-module-template]'
            );


          const host =
            panel.querySelector(
              '[data-iw-hub-module-host]'
            );


          if (
            !template ||
            !host
          ) {
            return;
          }


          /*
            The template already contains the
            Liquid-rendered film presentation,
            including its own CSS.
          */

          const source =
            template.innerHTML.trim();


          if (!source) {

            console.warn(
              'Instawraps Hub: coded module template is empty.'
            );

            return;
          }



          /* =================================================
             CREATE ISOLATED IFRAME
             ================================================= */

          const frame =
            document.createElement(
              'iframe'
            );


          frame.className =
            'iw-hub__module-frame';


          frame.setAttribute(
            'title',
            'Product information'
          );


          frame.setAttribute(
            'scrolling',
            'no'
          );


          frame.setAttribute(
            'frameborder',
            '0'
          );


          /*
            Temporary height until the module
            has finished rendering.
          */

          frame.style.height =
            '700px';


          host.replaceWith(
            frame
          );


          /*
            srcdoc gives each coded presentation
            its own CSS environment.

            This prevents the .iwpd CSS used by
            one film from affecting another film
            or the Product Hub itself.
          */

          frame.srcdoc =
            source;



          /* =================================================
             AUTO HEIGHT
             ================================================= */

          frame.addEventListener(
            'load',
            () => {

              try {

                const doc =
                  frame.contentDocument;


                if (
                  !doc ||
                  !doc.documentElement ||
                  !doc.body
                ) {
                  return;
                }



                /* ===========================================
                   REMOVE IFRAME BROWSER DEFAULTS
                   =========================================== */

                doc.documentElement.style.margin =
                  '0';


                doc.documentElement.style.padding =
                  '0';


                doc.documentElement.style.overflow =
                  'hidden';


                doc.body.style.margin =
                  '0';


                doc.body.style.padding =
                  '0';


                doc.body.style.overflow =
                  'hidden';



                /* ===========================================
                   MATCH STOREFRONT FONT
                   =========================================== */

                const storeFont =
                  getComputedStyle(
                    document.body
                  ).fontFamily;


                doc.body.style.fontFamily =
                  storeFont;


                  /* ===========================================
   SAFE LINK BEHAVIOR FOR CODED MODULES
   =========================================== */

/*
  Coded Hub modules live inside isolated
  srcdoc iframes.

  Rules:

  #anchor
    -> scroll to that section inside the Hub

  http / https
    -> open outside the iframe in a new tab

  mailto:
    -> normal email behavior

  tel:
    -> normal phone behavior
*/

doc.addEventListener(
  'click',
  event => {

    const link =
      event.target?.closest?.(
        'a[href]'
      );


    if (!link) {
      return;
    }


    const rawHref =
      link.getAttribute(
        'href'
      );


    if (!rawHref) {
      return;
    }



    /* =====================================
       INTERNAL MODULE ANCHORS
       ===================================== */

    if (
      rawHref.startsWith('#')
    ) {

      event.preventDefault();


      const hubContent =
        frame.closest(
          '[data-iw-hub-content]'
        );


      if (!hubContent) {
        return;
      }


      const targetId =
        decodeURIComponent(
          rawHref.substring(1)
        );


      /*
        Empty # link:
        return to top of this module.
      */

      if (!targetId) {

        const frameRect =
          frame.getBoundingClientRect();


        const contentRect =
          hubContent.getBoundingClientRect();


        const destination =
          hubContent.scrollTop +
          frameRect.top -
          contentRect.top -
          16;


        hubContent.scrollTo({
          top:
            Math.max(
              0,
              destination
            ),

          behavior:
            'smooth'
        });


        return;
      }


      const anchorTarget =
        doc.getElementById(
          targetId
        );


      if (!anchorTarget) {
        return;
      }


      const frameRect =
        frame.getBoundingClientRect();


      const contentRect =
        hubContent.getBoundingClientRect();


      const targetRect =
        anchorTarget.getBoundingClientRect();


      const destination =
        hubContent.scrollTop +
        (
          frameRect.top -
          contentRect.top
        ) +
        targetRect.top -
        18;


      hubContent.scrollTo({

        top:
          Math.max(
            0,
            destination
          ),

        behavior:
          'smooth'

      });


      return;
    }



    /* =====================================
       PHONE / EMAIL
       ===================================== */

    if (
      rawHref.startsWith(
        'mailto:'
      ) ||
      rawHref.startsWith(
        'tel:'
      )
    ) {
      return;
    }



    /* =====================================
       IGNORE JAVASCRIPT LINKS
       ===================================== */

    if (
      rawHref.startsWith(
        'javascript:'
      )
    ) {
      return;
    }



    /* =====================================
       NORMAL WEB LINKS
       ===================================== */

    let url;


    try {

      url =
        new URL(
          rawHref,
          window.location.href
        );

    }

    catch (error) {

      return;

    }


    if (
      url.protocol !== 'http:' &&
      url.protocol !== 'https:'
    ) {
      return;
    }


    event.preventDefault();


    window.open(
      url.href,
      '_blank',
      'noopener'
    );

  }
);



                /* ===========================================
                   FIND ACTUAL MODULE ROOT
                   =========================================== */

                const getModuleRoot = () => {

                  /*
                    Current product-detail film
                    modules use .iwpd.

                    The fallback makes the engine
                    safer for future coded modules
                    that may use another wrapper.
                  */

                  const iwpd =
                    doc.querySelector(
                      '.iwpd'
                    );


                  if (iwpd) {
                    return iwpd;
                  }


                  const candidates =
                    Array.from(
                      doc.body.children
                    )
                    .filter(element => {

                      return ![
                        'STYLE',
                        'SCRIPT',
                        'LINK',
                        'META'
                      ].includes(
                        element.tagName
                      );

                    });


                  return (
                    candidates[0] ||
                    null
                  );

                };



                /* ===========================================
                   RESIZE FRAME
                   =========================================== */

                const resizeFrame = () => {

                  const moduleRoot =
                    getModuleRoot();


                  if (!moduleRoot) {
                    return;
                  }


                  const rect =
                    moduleRoot
                      .getBoundingClientRect();


                  const styles =
                    doc.defaultView
                      .getComputedStyle(
                        moduleRoot
                      );


                  const marginTop =
                    parseFloat(
                      styles.marginTop
                    ) || 0;


                  const marginBottom =
                    parseFloat(
                      styles.marginBottom
                    ) || 0;


                  const height =
                    Math.ceil(
                      rect.height +
                      marginTop +
                      marginBottom
                    );


                  if (
                    height > 0
                  ) {

                    frame.style.height =
                      `${height + 2}px`;

                  }

                };



                /* ===========================================
                   INITIAL SIZING
                   =========================================== */

                requestAnimationFrame(
                  resizeFrame
                );


                setTimeout(
                  resizeFrame,
                  100
                );


                setTimeout(
                  resizeFrame,
                  300
                );


                setTimeout(
                  resizeFrame,
                  700
                );



                /* ===========================================
                   WATCH MODULE SIZE
                   =========================================== */

                if (
                  'ResizeObserver' in
                    window
                ) {

                  const moduleRoot =
                    getModuleRoot();


                  if (moduleRoot) {

                    const resizeObserver =
                      new ResizeObserver(
                        () => {

                          requestAnimationFrame(
                            resizeFrame
                          );

                        }
                      );


                    resizeObserver.observe(
                      moduleRoot
                    );


                    frame.__iwResizeObserver =
                      resizeObserver;

                  }

                }



                /* ===========================================
                   DETAILS / ACCORDIONS
                   =========================================== */

                /*
                  Some coded presentations contain
                  expandable technical sections.

                  Recalculate immediately whenever
                  one opens or closes.
                */

                doc.addEventListener(
                  'toggle',
                  () => {

                    requestAnimationFrame(
                      resizeFrame
                    );


                    setTimeout(
                      resizeFrame,
                      100
                    );

                  },
                  true
                );



                /* ===========================================
                   IMAGES
                   =========================================== */

                Array.from(
                  doc.images
                )
                .forEach(image => {

                  if (
                    !image.complete
                  ) {

                    image.addEventListener(
                      'load',
                      resizeFrame
                    );

                  }

                });


              }

              catch (error) {

                console.warn(
                  'Instawraps Hub module resize:',
                  error
                );

              }

            }
          );

        };



        /* =====================================================
           SHOW A HUB VIEW
           ===================================================== */

        const showView = view => {

          const targetPanel =
            panels.find(
              panel =>
                panel.dataset.iwHubPanel ===
                view
            );


          if (!targetPanel) {
            return;
          }



          /* =================================
             SWITCH PANEL
             ================================= */

          panels.forEach(panel => {

            panel.classList.toggle(
              'is-active',
              panel === targetPanel
            );

          });



          /* =================================
             LOAD CODED MODULE IF REQUIRED
             ================================= */

          loadModule(
            targetPanel
          );



          /* =================================
             MAIN NAV ACTIVE STATE
             ================================= */

          const mainCategory =
            getMainCategory(
              view
            );


          viewButtons.forEach(button => {

            const buttonView =
              button.dataset.iwHubView;


            const buttonMain =
              button.dataset.iwHubMain;


            const active =
              buttonView === view ||
              (
                buttonMain &&
                buttonMain ===
                  mainCategory
              );


            button.classList.toggle(
              'is-active',
              active
            );

          });



          /* =================================
             TOPBAR TITLE
             ================================= */

          if (
            topbarTitle
          ) {

            topbarTitle.textContent =
              viewTitles[view] ||
              'Product Information Hub';

          }



          /* =================================
             HUB HOME BUTTON
             ================================= */

          if (
            homeButton
          ) {

            /*
              The Hub Home action has no purpose
              while the customer is already on
              the Hub homepage.
            */

            homeButton.hidden =
              view === 'home';

          }



          /* =================================
             RETURN CONTENT TO TOP
             ================================= */

          if (
            content
          ) {

            content.scrollTop =
              0;

          }


          root.dataset.currentView =
            view;

        };



        /* =====================================================
           OPEN HUB
           ===================================================== */

        const openHub = view => {

          lastFocusedElement =
            document.activeElement;


          showView(
            view ||
            'home'
          );


          overlay.classList.add(
            'is-open'
          );


          overlay.setAttribute(
            'aria-hidden',
            'false'
          );


          document.body.classList.add(
            'iw-hub-lock'
          );


          document
            .documentElement
            .classList
            .add(
              'iw-hub-html-lock'
            );


          requestAnimationFrame(
            () => {

              const closeButton =
                overlay.querySelector(
                  '[data-iw-hub-close]'
                );


              if (
                closeButton
              ) {

                try {

                  closeButton.focus({
                    preventScroll: true
                  });

                }

                catch (error) {

                  closeButton.focus();

                }

              }

            }
          );

        };



        /* =====================================================
           CLOSE HUB
           ===================================================== */

        const closeHub = () => {

          overlay.classList.remove(
            'is-open'
          );


          overlay.setAttribute(
            'aria-hidden',
            'true'
          );


          document.body.classList.remove(
            'iw-hub-lock'
          );


          document
            .documentElement
            .classList
            .remove(
              'iw-hub-html-lock'
            );


          if (
            lastFocusedElement &&
            typeof
              lastFocusedElement.focus ===
              'function'
          ) {

            requestAnimationFrame(
              () => {

                try {

                  lastFocusedElement.focus({
                    preventScroll: true
                  });

                }

                catch (error) {

                  lastFocusedElement.focus();

                }

              }
            );

          }

        };



        /* =====================================================
           LAUNCHER
           ===================================================== */

        openButton.addEventListener(
          'click',
          () => {

            openHub(
              'home'
            );

          }
        );



        /* =====================================================
           CLOSE BUTTONS
           ===================================================== */

        closeButtons.forEach(
          button => {

            button.addEventListener(
              'click',
              closeHub
            );

          }
        );



        /* =====================================================
           HUB NAVIGATION
           ===================================================== */

        viewButtons.forEach(
          button => {

            if (
              button ===
              openButton
            ) {
              return;
            }


            button.addEventListener(
              'click',
              event => {

                event.preventDefault();


                const view =
                  button.dataset
                    .iwHubView;


                if (!view) {
                  return;
                }


                showView(
                  view
                );

              }
            );

          }
        );



        /* =====================================================
           BACKDROP CLICK
           ===================================================== */

        overlay.addEventListener(
          'mousedown',
          event => {

            if (
              event.target ===
              overlay
            ) {

              closeHub();

            }

          }
        );



        /* =====================================================
           ESCAPE KEY
           ===================================================== */

        document.addEventListener(
          'keydown',
          event => {

            if (
              event.key !==
                'Escape' ||
              !overlay
                .classList
                .contains(
                  'is-open'
                )
            ) {
              return;
            }


            event.preventDefault();


            closeHub();

          }
        );



        /* =====================================================
           ACCESSIBILITY FOCUS TRAP
           ===================================================== */

        modal.addEventListener(
          'keydown',
          event => {

            if (
              event.key !==
              'Tab'
            ) {
              return;
            }


            const focusable =
              Array.from(
                modal.querySelectorAll(
                  `
                    button:not([disabled]),
                    a[href],
                    input:not([disabled]),
                    select:not([disabled]),
                    textarea:not([disabled]),
                    iframe,
                    [tabindex]:not([tabindex="-1"])
                  `
                )
              )
              .filter(
                element => {

                  return (
                    element.offsetParent !==
                      null &&
                    getComputedStyle(
                      element
                    ).visibility !==
                      'hidden'
                  );

                }
              );


            if (
              !focusable.length
            ) {
              return;
            }


            const first =
              focusable[0];


            const last =
              focusable[
                focusable.length - 1
              ];


            if (
              event.shiftKey &&
              document.activeElement ===
                first
            ) {

              event.preventDefault();

              last.focus();

            }


            else if (
              !event.shiftKey &&
              document.activeElement ===
                last
            ) {

              event.preventDefault();

              first.focus();

            }

          }
        );



        /* =====================================================
           INITIAL VIEW
           ===================================================== */

        showView(
          'home'
        );

      });

  };



  /* =========================================================
     INITIAL PAGE LOAD
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeHubs
    );

  }

  else {

    initializeHubs();

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    initializeHubs
  );

})();